module.exports = __webpack_public_path__ + "static/media/wheelBackground.7da63915.svg";